(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    /*
    StickyCartBar — versione agganciata a Globo Product Options.
    L'app Globo inietta i selettori varianti (non il variant picker nativo del tema).
    Struttura Globo per ogni opzione:
      <div class="swatch--gl" data-option-index="N">
        <legend class="name-option" data-name="...">Nome</legend>
        <ul class="value glider-variant-product-detail">
          <li class="select-option [globo-out-of-stock]" data-value="S" data-variantid="123">
            <label class="swatch-anchor ...">S</label>
          </li>
          ...
    Strategia di abbinamento: per VALORE, non per nome opzione (i nomi possono
    divergere per via dei connettori dinamici di Globo). Un gruppo Globo
    corrisponde al <select> della sticky che contiene gli stessi valori.
  */
  class StickyCartBar extends HTMLElement {
    constructor() {
      super();
      this.hasOnlyDefault = this.dataset.hasOnlyDefault === 'true';
      this.priceSourceSelector = this.dataset.priceSource;

      this.submitBtn = this.querySelector('[data-sticky-submit]');
      this.priceTarget = this.querySelector('[data-sticky-price]');
      this.notice = this.querySelector('[data-sticky-notice]');
      this.selects = Array.from(this.querySelectorAll('[data-sticky-option]'));

      this.variants = this.readVariants();
      this.globoGroups = [];

      this.onScroll = this.onScroll.bind(this);
      this.syncFromGlobo = this.syncFromGlobo.bind(this);
    }

    connectedCallback() {
      this.priceSource = document.querySelector(this.priceSourceSelector);

      // Globo viene iniettato in modo asincrono: attendiamo che i gruppi esistano.
      this.waitForGlobo(0);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      if (this.globoObserver) this.globoObserver.disconnect();
    }

    readVariants() {
      const node = this.querySelector('[data-sticky-variants]');
      if (!node) return [];
      try { return JSON.parse(node.textContent); } catch (e) { return []; }
    }

    onScroll() {
      if (window.scrollY > 30) this.classList.add('is-visible');
      else this.classList.remove('is-visible');
    }

    /* Attende che Globo abbia iniettato i selettori, poi inizializza. Max ~5s. */
    waitForGlobo(attempt) {
      if (this.hasOnlyDefault) { this.updateState(); return; }
      const groups = document.querySelectorAll('.swatch--gl[data-option-index]');
      if (groups.length > 0) {
        this.mapGloboGroups(groups);
        this.bindSelects();
        this.bindGloboSync();
        this.refreshOptionAvailability();
        this.updateState();
        this.updatePrice();
        return;
      }
      if (attempt < 50) {
        setTimeout(() => this.waitForGlobo(attempt + 1), 100);
      } else {
        // Globo non trovato: la sticky resta usabile, il bottone parte abilitato
        // ma il controllo finale anti-errore (variante reale) resta attivo.
        this.updateState();
      }
    }

    /*
      Abbina ogni <select> della sticky al gruppo Globo che contiene gli stessi
      valori. Per ogni gruppo salva i <li> indicizzati per data-value.
    */
    mapGloboGroups(groups) {
      const groupData = Array.from(groups).map((groupEl) => {
        const items = Array.from(groupEl.querySelectorAll('li.select-option[data-value]'));
        const valueMap = {};
        items.forEach((li) => {
          const val = li.getAttribute('data-value');
          valueMap[val] = li;
        });
        return { el: groupEl, valueMap, values: Object.keys(valueMap) };
      });

      this.selects.forEach((select) => {
        const selectValues = Array.from(select.options)
          .map((o) => o.value)
          .filter((v) => v !== '');
        // Il gruppo giusto e' quello che contiene tutti i valori di questo select
        const match = groupData.find((g) =>
          selectValues.every((v) => g.values.includes(v))
        );
        if (match) {
          this.globoGroups.push({ select: select, group: match });
        }
      });
    }

    groupForSelect(select) {
      const entry = this.globoGroups.find((g) => g.select === select);
      return entry ? entry.group : null;
    }

    /* Click reale sulla label Globo del valore scelto -> fa scattare Globo (foto incluse) */
    clickGlobo(group, value) {
      const li = group.valueMap[value];
      if (!li) return;
      const label = li.querySelector('label.swatch-anchor') || li.querySelector('label') || li;
      label.click();
    }

    chosenValues() {
      const values = {};
      this.selects.forEach((s) => {
        values[parseInt(s.dataset.stickyOption, 10)] = s.value || null;
      });
      return values;
    }

    matchesChosen(variant, chosen, ignorePosition) {
      return Object.keys(chosen).every((posStr) => {
        const pos = parseInt(posStr, 10);
        if (pos === ignorePosition) return true;
        const chosenVal = chosen[pos];
        if (!chosenVal) return true;
        return variant.options[pos - 1] === chosenVal;
      });
    }

    refreshOptionAvailability() {
      if (this.hasOnlyDefault) return;
      const chosen = this.chosenValues();
      this.selects.forEach((select) => {
        const pos = parseInt(select.dataset.stickyOption, 10);
        Array.from(select.options).forEach((opt) => {
          if (opt.value === '') return;
          const available = this.variants.some((v) =>
            v.available &&
            v.options[pos - 1] === opt.value &&
            this.matchesChosen(v, chosen, pos)
          );
          opt.textContent = opt.textContent.replace(/\s*\(esaurito\)\s*$/, '');
          if (!available) {
            opt.disabled = true;
            opt.textContent = opt.textContent + ' (esaurito)';
          } else {
            opt.disabled = false;
          }
        });
      });
    }

    bindSelects() {
      this.selects.forEach((select) => {
        select.addEventListener('change', () => {
          const group = this.groupForSelect(select);
          if (group) this.clickGlobo(group, select.value);
          this.refreshOptionAvailability();
          this.updateState();
          // Il prezzo si aggiorna dopo che Globo ha ricalcolato: piccolo ritardo
          setTimeout(() => this.updatePrice(), 150);
        });
      });
    }

    /* Sync inverso: l'utente cambia su Globo -> aggiorna i select della sticky */
    bindGloboSync() {
      this.globoGroups.forEach(({ select, group }) => {
        group.el.addEventListener('click', (e) => {
          const li = e.target.closest('li.select-option[data-value]');
          if (!li) return;
          const value = li.getAttribute('data-value');
          if (select.value !== value) {
            select.value = value;
          }
          this.refreshOptionAvailability();
          this.updateState();
          setTimeout(() => this.updatePrice(), 150);
        });
      });
    }

    syncFromGlobo() {
      this.globoGroups.forEach(({ select, group }) => {
        const checked = group.el.querySelector('li.select-option.selected, li.select-option[data-selected="true"]');
        if (checked) {
          const value = checked.getAttribute('data-value');
          if (value && select.value !== value) select.value = value;
        }
      });
      this.refreshOptionAvailability();
      this.updateState();
    }

    updatePrice() {
      if (!this.priceSource || !this.priceTarget) return;
      const sale = this.priceSource.querySelector('.price-item--sale');
      const regular = this.priceSource.querySelector('.price-item--regular');
      let text = '';
      if (sale && sale.offsetParent !== null) text = sale.textContent;
      else if (regular) text = regular.textContent;
      text = (text || '').trim();
      if (text) this.priceTarget.textContent = text;
    }

    matchedVariant() {
      const chosen = this.chosenValues();
      const allChosen = Object.values(chosen).every((v) => v);
      if (!allChosen) return null;
      return this.variants.find((v) =>
        Object.keys(chosen).every((posStr) => {
          const pos = parseInt(posStr, 10);
          return v.options[pos - 1] === chosen[pos];
        })
      ) || null;
    }

    showNotice(msg) {
      if (!this.notice) return;
      if (msg) { this.notice.textContent = msg; this.notice.hidden = false; }
      else { this.notice.hidden = true; }
    }

    updateState() {
      if (this.hasOnlyDefault) { this.submitBtn.disabled = false; return; }
      const allChosen = this.selects.every((s) => s.value !== '');
      if (!allChosen) { this.submitBtn.disabled = true; this.showNotice(null); return; }
      const variant = this.matchedVariant();
      if (!variant) { this.submitBtn.disabled = true; this.showNotice('Combinazione non disponibile'); }
      else if (!variant.available) { this.submitBtn.disabled = true; this.showNotice('Esaurito'); }
      else { this.submitBtn.disabled = false; this.showNotice(null); }
    }
  }

  if (!customElements.get('sticky-cart-bar')) {
    customElements.define('sticky-cart-bar', StickyCartBar);
  }
  } catch(e) { console.error(e); }
})();

})();
